import React, { useContext, useEffect, useState, useCallback, useRef } from "react";
import { Link, useParams, useLocation } from "wouter";
import { AuthContext } from "../contexts/auth";
import { v2FetchEmployee, resetDipendentePassword, deleteDipendente } from "../services/api";
import { Popover } from "@headlessui/react";
import { CheckCircleIcon, XCircleIcon, BriefcaseIcon, EyeSlashIcon, PowerIcon, ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";
import { EyeIcon } from '@heroicons/react/20/solid';
import moment from "moment";
import Swal from "sweetalert2";
import { updateAnagraficaEmployee } from "../services/api_anagrafica_employee";

import BackButton from "../components/back_button";
import Footer from "../components/footer";
import Fetching from "../components/fetching";
import FilePreviewModal from "../components/preview_modal";
import NotAuthorized from "../authorization/NotAuthorized";
import NoPermissions from "../authorization/NoPermissions";

import ResiduiContent from "../components/residui_tab_content";
import TimbraturaTabEmployee from "../components/timbratura_tab_employee";
import PermissionsEmployeeTable from "../components/permessi_employee_table";
import EmployeeRoleUnits from "../components/employee_role_unit";
import DocumentiContent from "../components/documenti_employee_content";
import VeicoliTabEmployee from "../components/vehicle_tab_employee";
import BustePagaTab from "../components/buste_tab_employee";
import CuTabEmployee from "../components/cu_tab_employee";

import { getEmployeeContractsList } from "../services/api_contracts_employee";
import { getRateosEmployeeList } from "../services/api_rateos";
import { getWeeklyWorkingHourCompound, getEmployeeWeeklyWorkingHour } from "../services/api_working_hours";
import { getEmployeeBalances } from "../services/api_balances";
import { getPermissionsDetailed } from "../services/api_permissions";
import EmployeesPrevNextNav from "../components/prev_next_buttons";
import CustomTooltipComponent from "../components/custom_tooltip_component";

// --------- helpers locali ---------------------------------

const formatMinutesToHoursTop = (minutes) => {
  const totalHours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (totalHours === 0 && remainingMinutes === 0) {
      return '0 MIN';
  } else if (totalHours === 0) {
      return `${remainingMinutes} MIN`;
  } else if (remainingMinutes === 0) {
      return `${totalHours} H`;
  } else {
      return `${totalHours} H, ${remainingMinutes} MIN`;
  }
};


// --------- sottocomponenti di contenuto tab ----------------

const RenderContrattoContent = (employee, contractsData) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    return formattedDate;
  };

  const shiftTypeDescriptions = {
    fisso: 'Fisso',
    turno: 'Turno',
    a_chiamata: 'A Chiamata',
    senza_calendario: 'Senza Calendario',
  };

  const getShiftTypeDescription = (shiftType) => {
    return shiftTypeDescriptions[shiftType] || shiftType;
  };

  return (
    <div>
      <div className="pt-2 pb-4">
        <Link
          to={`/dipendenti/${employee?.cf}/edit?tab=2`}
          className="relative w-24 justify-center mt-2 inline-flex items-center rounded-sm bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          {contractsData && contractsData.length > 0 ? 'Modifica' : 'Aggiungi'}
        </Link>
      </div>

      {/* VISUALIZZAZIONE DEL CONTRATTO ATTIVO IN ANAGRAFICA */}
      {contractsData && contractsData.length > 0 ? (
        <div className="min-w-full">
          {contractsData.some((contract) => contract.is_active) && (
            <div className="uppercase font-semibold text-indigo-700">
              <CheckCircleIcon className="inline-block mb-1 w-5 h-5" />{" "}
              Contratto attivo
            </div>
          )}

          {contractsData
            .filter((contract) => contract.is_active)
            .map((contract) => (
              <div key={contract.id}>
                <div className="grid grid-cols-2 pt-3">
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Data Inizio
                  </div>
                  <div className="col col-span-1 block text-sm py-1 font-medium text-gray-700">
                    {formatDate(contract?.start_date)}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Data Fine
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.end_date ? formatDate(contract?.end_date) : "-"}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Tipologia Turno
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {getShiftTypeDescription(contract?.shift_type)}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Ore Settimanali
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.week_hours}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Tipologia Contrattuale
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.typology?.description}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    CCNL
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.ccnl?.codice} - {contract?.ccnl?.nome}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Qualifica Professionale
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.qualification?.descrizione}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Livello Inquadramento
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.classification_level?.cod_livello} -{" "}
                    {contract?.classification_level?.des_livello}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Tipo Orario
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.working_hour_types?.nome}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Retribuzione (RAL)
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.ral}
                  </div>
                  {/* <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Costo Orario Del Lavoro
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.hourly_labor_cost}
                  </div> */}
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Ente Previdenziale
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.social_security_institution?.description}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    PAT Inail
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.pat_inail}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Socio Lavoratore
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.is_working_partner === true 
                    ? 'SI' 
                    : contract?.is_working_partner === false 
                      ? 'NO' 
                      : null}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Lavoratore in Mobilità
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.is_mobile_worker === true
                      ? "SI"
                      : contract?.is_mobile_worker === false
                      ? "NO"
                      : null}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Lavoro Stagionale
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.is_seasonal_work === true
                      ? "SI"
                      : contract?.is_seasonal_work === false
                      ? "NO"
                      : null}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Lavoro in Agricoltura
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.is_agriculture === true
                      ? 'SI'
                      : contract?.is_agriculture === false
                      ? 'NO'
                      : null}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Profilo Giustificativi
                  </div>

                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.justification_profile?.name || '-'}
                  </div>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div className="border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-semibold text-gray-900">
          Nessun contratto attivo
        </div>
      )}

      {/* VISUALIZZAZIONE DEI CONTRATTI NON ATTIVI IN ANAGRAFICA */}
      {contractsData && contractsData.length > 0 ? (
        <div className="min-w-full">
          {contractsData
            .filter((contract) => !contract.is_active)
            .sort(
              (a, b) =>
                new Date(b.start_date) - new Date(a.start_date)
            )
            .map((contract) => (
              <div key={contract.id} className="mt-6">
                <div className="uppercase font-semibold text-gray-500">
                  <XCircleIcon className="inline-block mb-1 me-1 w-5 h-5" />
                  Contratto non attivo
                </div>
                <div className="grid grid-cols-2 pt-3">
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Data Inizio
                  </div>
                  <div className="col col-span-1 block text-sm py-1 font-medium text-gray-700">
                    {formatDate(contract.start_date)}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Data Fine
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {formatDate(contract.end_date)}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Tipologia Turno
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {getShiftTypeDescription(contract.shift_type)}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Ore Settimanali
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract.week_hours}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Tipologia Contrattuale
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract.typology?.description}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    CCNL
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.ccnl?.codice} - {contract?.ccnl?.nome}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Qualifica Professionale
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract.qualification?.descrizione}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Livello Inquadramento
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract.classification_level?.cod_livello} -{" "}
                    {contract.classification_level?.des_livello}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Tipo Orario
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract.working_hours_type?.codice} -{" "}
                    {contract.working_hours_type?.nome}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Retribuzione (RAL)
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract.ral}
                  </div>
                  {/* <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Costo Orario Del Lavoro
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.hourly_labor_cost}
                  </div> */}
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Ente Previdenziale
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract.social_security_institution?.description}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    PAT Inail
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract.pat_inail}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Socio Lavoratore
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.is_working_partner === true
                      ? 'SI'
                      : contract?.is_working_partner === false
                      ? 'NO'
                      : null}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Lavoratore in Mobilità
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.is_mobile_worker === true
                      ? 'SI'
                      : contract?.is_mobile_worker === false
                      ? 'NO'
                      : null}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Lavoro Stagionale
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.is_seasonal_work === true
                      ? 'SI'
                      : contract?.is_seasonal_work === false
                      ? 'NO'
                      : null}
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-900">
                    Lavoro in Agricoltura
                  </div>
                  <div className="col col-span-1 text-left text-sm py-1 text-gray-900">
                    {contract?.is_agriculture === true
                      ? 'SI'
                      : contract?.is_agriculture === false
                      ? 'NO'
                      : null}
                  </div>
                </div>
              </div>
            ))}
        </div>
      ) : null}
    </div>
  );
};

const RenderRateiContent = (employee, rateiEmployee) => {
  const formatDate = (dateString) => {
    if (typeof dateString !== 'string') {
      return '';
    }
    const parts = dateString.split('-');
    if (parts.length !== 3) {
      return '';
    }
    const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    return formattedDate;
  };

  const formatMinutesToHours = (minutes) => {
    const totalHours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (totalHours === 0 && remainingMinutes === 0) {
        return '0 min';
    } else if (totalHours === 0) {
        return `${remainingMinutes} min / mese`;
    } else if (remainingMinutes === 0) {
        return `${totalHours} h / mese`;
    } else {
        return `${totalHours} h, ${remainingMinutes} min / mese`;
    }
  };

  return (
    <div>
      <div className="pt-2 pb-4">
        <Link
          to={`/dipendenti/${employee?.cf}/edit?tab=3`}
          className="relative w-24 justify-center mt-2 inline-flex items-center rounded-sm bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          {rateiEmployee && rateiEmployee.length > 0 ? 'Modifica' : 'Aggiungi'}
        </Link>
      </div>
      {rateiEmployee.length > 0 ? (
        <div className="min-w-full">
          {rateiEmployee.map((rateo) => (
            <div key={rateo.id} className="mb-3 border-b">
              <div className="uppercase font-semibold text-indigo-700">
                {rateo.rateo.rateo.name}
              </div>
              <div className="grid grid-cols-2">
                <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-700">
                  Data Inizio
                </div>
                <div className="col col-span-1 block text-sm py-1 font-medium text-gray-700">
                  {formatDate(rateo.date_from)}
                </div>
                <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-700">
                  Data Fine
                </div>
                <div className="col col-span-1 text-left text-sm py-1 text-gray-700">
                  {formatDate(rateo.date_to)}
                </div>
                <div className="col col-span-1 text-left text-sm py-1 font-semibold text-gray-700">
                  Coefficiente di maturazione
                </div>
                <div className="col col-span-1 text-left text-sm py-1 text-gray-700 pb-3">
                  {formatMinutesToHours(rateo.monthly_increase)}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="m-8 border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-semibold text-gray-900">
          <div className="text-center p-5">
            <p>Non sono presenti ratei attivi</p>
          </div>
        </div>
      )}
    </div>
  );
};

const RenderTurnoContent = (employee, employeeShift, profile, isContrattoNonFisso, isSenzaCalendario, shiftLoading) => {
  const hasPermission = (
    profile?.employee?.permissions.includes('hr.view_shifts_ou') || 
    profile?.employee?.permissions.includes('hr.view_shifts_all') ||
    profile?.employee?.permissions.includes('hr.manage_shifts_ou') ||
    profile?.employee?.permissions.includes('hr.manage_shifts_all')
  );
  
  if (profile.customer_type === 'employee' && !hasPermission) {
    return (
      <>
        <NoPermissions />
      </>
    );
  }

  if (shiftLoading) {
    return <Fetching />;
  }
  
  if (isSenzaCalendario) {
    return (
      <div className="pt-2 pb-4">
        <div className="m-8 border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-semibold text-gray-900">
          <div className="text-center p-5">
            <p>
              La tipologia di contratto del dipendente è{" "}
              <span className="text-indigo-800">"Senza Calendario"</span> e non è
              possibile assegnare turni di lavoro.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isContrattoNonFisso) {
    return (
      <div className="pt-2 pb-4">
        <Link
          to={`/dipendenti/${employee?.cf}/edit?tab=4`}
          className="relative w-24 justify-center mt-2 inline-flex items-center rounded-sm bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Modifica
        </Link>
        <div className="m-8 border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-semibold text-gray-900">
          <div className="text-center p-5">
            <p>
              La tipologia di contratto del dipendente è diversa da Fisso. <br />
              I turni sono visualizzabili e assegnabili nel calendario{" "}
              <Link
                to="/assign_working_hour"
                className="text-indigo-700 underline font-semibold"
              >
                ASSEGNA TURNI
              </Link>
            </p>
          </div>
        </div>
      </div>
    );
  }
  const daysOfWeek = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica']; 
  
  return (
    <div>
      <div className="pt-2 pb-4">
        <Link
          to={`/dipendenti/${employee?.cf}/edit?tab=4`}
          className="relative w-24 justify-center mt-2 inline-flex items-center rounded-sm bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          {employeeShift ? 'Modifica' : 'Aggiungi'}
        </Link>
      </div>
      {employeeShift ? (
        <div className='mx-4 mb-10'>
          {employeeShift && (
            <div className="flex justify-between">
              <h3 className='block text-sm font-medium text-gray-700'>
                Turno assegnato:{" "}
                <span className="uppercase font-semibold text-indigo-700">
                  {employeeShift.name}
                </span>
              </h3>
              <h3 className="block text-sm font-medium text-gray-700">
                Totale Ore Settimanali:{" "}
                <span className="uppercase font-semibold text-indigo-700">
                  {formatMinutesToHoursTop(employeeShift.duration)}
                </span>
              </h3>
            </div>
          )}

          {employeeShift && (
            <div className='mt-4 overflow-x-auto overflow-visible'>
              <table className="w-full rounded-md border-collapse overflow-auto" style={{ maxWidth: '100%' }}>
                <tbody>
                  {daysOfWeek.map((day, rowIndex) => (
                    <tr key={rowIndex}>
                      <td className="px-4 py-2 text-sm font-bold text-center whitespace-nowrap text-gray-500 border border-gray-300 rounded-md" style={{ width: '30%' }}>
                        {day}
                      </td>
                      <td className="px-4 py-2 text-sm text-center whitespace-nowrap text-gray-700 align-top border border-gray-300 rounded-md" style={{ width: '70%' }}>
                        {(employeeShift.slots_by_weekday || []).flatMap((weekDay) => {
                          if (weekDay.week_day - 1 === rowIndex) {
                            const timeSlots = weekDay.working_hour?.time_slots || [];
                            const additionalTimeSlots = weekDay.time_slots || [];
                            const allTimeSlots = [...timeSlots, ...additionalTimeSlots];

                            allTimeSlots.sort((a, b) => {
                              const timeA = new Date(`1970-01-01T${a.start_at}`);
                              const timeB = new Date(`1970-01-01T${b.start_at}`);
                              return timeA.getTime() - timeB.getTime();
                            });

                            return allTimeSlots.map((timeSlot, timeSlotIndex) => (
                              <div key={`${rowIndex}-${timeSlotIndex}`} className="mt-2 mb-5">
                                <BriefcaseIcon className='h-5 w-5 inline-block' />
                                <span 
                                  className="font-bold underline-offset-4" 
                                  style={{
                                    textDecoration: 'underline',
                                    textDecorationColor: '#2b6cb0',
                                    textDecorationThickness: '1px',
                                }}>
                                {timeSlot.start_at} - {timeSlot.end_at}
                                </span>
                                {timeSlot.breaks.map((breakItem, breakIndex) => (
                                  <div key={breakIndex} className="my-1">
                                    <span className="inline-block w-5 h-5 pt-2 me-1">
                                      <SvgBreak />
                                    </span>
                                    {!breakItem?.is_visible && (
                                      <EyeSlashIcon className="inline h-4 w-4 text-red-500 align-middle me-1" strokeWidth={2} />
                                    )}
                                    {`${breakItem.start_at} - ${breakItem.end_at}`}
                                  </div>
                                ))}
                              </div>
                            ));
                          }
                          return null;
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : (
        <div className="m-8 border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-semibold text-gray-900">
          <div className="text-center p-5">
            <p>Non sono presenti turni assegnati</p>
          </div>
        </div>
      )}
    </div>
  );
};

const RenderTimbraturaContent = (employee, profile) => {
  const hasPermission = (
    profile?.employee?.permissions.includes('hr.view_inouts_all') || 
    profile?.employee?.permissions.includes('hr.view_inouts_ou') ||
    profile?.employee?.permissions.includes('hr.manage_inouts_all') || 
    profile?.employee?.permissions.includes('hr.manage_inouts_ou')
  );  

  if (profile?.customer_type === 'employee' && !hasPermission) {
    return (
      <>
        <NoPermissions />
      </>
    );
  }

  return (
    <div>
      <TimbraturaTabEmployee employee={employee?.id} />
    </div>
  );
};

const RenderVeicoliContent = (employee, profile) => {
  const hasPermission = (
    profile?.employee?.permissions.includes('hr.manage_refunds_all') || 
    profile?.employee?.permissions.includes('hr.manage_refunds_ou')
  );  

  if (profile?.customer_type === 'employee' && !hasPermission) {
    return (
      <>
        <NoPermissions />
      </>
    );
  }

  return (
    <div>
      <VeicoliTabEmployee employeeId={employee?.id} />
    </div>
  );
};

const RenderRuoloContent = (
  employee,
  permissions,
  handlerPermissions,
  employeePermissions,
  permissionsDetailed
) => {
  return (
    <div>
      <div className="py-2">
        <Link
          to={`/dipendenti/${employee?.cf}/edit?tab=5`}
          className="relative w-24 justify-center mt-2 inline-flex items-center rounded-sm bg-indigo-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          {permissions && permissions.length > 0 ? "Modifica" : "Aggiungi"}
        </Link>
        <EmployeeRoleUnits employeeId={employee?.id} fromPage='employeeView' />
      </div>


      <PermissionsEmployeeTable
        title="GESTORE"
        permissions={handlerPermissions}
        activePermissions={permissions}
        permissionsDetailed={permissionsDetailed}
        mode="view"
        prefix="handler"
      />

      <PermissionsEmployeeTable
        title="DIPENDENTE"
        permissions={employeePermissions}
        activePermissions={permissions}
        permissionsDetailed={permissionsDetailed}
        mode="view"
        prefix="employee"
      />
    </div>
  );
};

// --------- COMPONENTE PRINCIPALE --------------------------

export default function Employee() {
  const { codiceFiscale } = useParams();

  const { profile, token } = useContext(AuthContext);
  const searchParams = new URLSearchParams(window.location.search);

  const [fetching, setFetching] = useState(true);
  const [employee, setEmployee] = useState(null);
  const [location, setLocation] = useLocation();

  const [activeMenuItem, setActiveMenuItem] = useState(
    searchParams.get("tab") || "buste_paga"
  );

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [contractsData, setContractsData] = useState(null);
  const [rateiEmployee, setRateiEmployee] = useState([]);

  const [employeeShift, setEmployeeShift] = useState(null);
  const [employeeBalances, setEmployeeBalances] = useState(null);

  const [permissions, setPermissions] = useState([]);
  const [handlerPermissions, setHandlerPermissions] = useState([]);
  const [employeePermissions, setEmployeePermissions] = useState([]);
  const [permissionsDetailed, setPermissionsDetailed] = useState([]);

  const [notFound, setNotFound] = useState(null);
  const [isContrattoNonFisso, setIsContrattoNonFisso] = useState(false);
  const [isSenzaCalendario, setIsSenzaCalendario] = useState(false);

  const [documentsTab, setDocumentsTab] = useState('caricati');
  const [previewDoc, setPreviewDoc] = useState(null);

  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1280);
  const [shiftLoading, setShiftLoading] = useState(false);

  const [isEditingNotes, setIsEditingNotes] = useState(false);
  const [isSavingNotes, setIsSavingNotes] = useState(false);
  const [notesDraft, setNotesDraft] = useState("");

  const reqIdRef = useRef(0);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1280);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const hasConsultalaHRPro =
    profile && profile.level && profile.level.hasOwnProperty("consultala_hr_pro");

  const resetPassword = () => {
    Swal.fire({
      title: "Sei sicuro di voler resettare la password?",
      text: "Una volta resettata il dipendente riceverà una mail con la nuova password e non sarà più possibile accedere con la vecchia password! Ricordati di verificare anche nella posta indesiderata.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, sono sicuro!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        resetDipendentePassword(token, employee?.id)
          .then((res) => {
            Swal.fire(
              "Password cambiata con successo!",
              "La password è stata cambiata con successo e una mail è stata inviata al dipendente.",
              "success"
            );
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops... qualcosa è andato storto!",
              text: err.message,
            });
          });
      }
    });
  };

  // 1. fetch dati employee
  useEffect(() => {
    if (!token || !codiceFiscale) return;

    const controller = new AbortController();
    const myReqId = ++reqIdRef.current;

    // RESET HARD (anche i flag turno!)
    setFetching(true);
    setEmployee(null);
    setError(null);
    setNotFound(null);

    setIsEditingNotes(false);
    setIsSavingNotes(false);
    setNotesDraft("");

    setContractsData(null);
    setRateiEmployee([]);
    setEmployeeShift(null);
    setEmployeeBalances(null);

    setIsContrattoNonFisso(false);
    setIsSenzaCalendario(false);

    setPermissions([]);
    setHandlerPermissions([]);
    setEmployeePermissions([]);
    setPermissionsDetailed([]);

    setPreviewDoc(null);

    v2FetchEmployee(token, codiceFiscale, "payrolls", controller.signal)
      .then((res) => {
        if (reqIdRef.current !== myReqId) return;
        setEmployee(res);
      })
      .catch((err) => {
          if (err?.name === "CanceledError" || err?.code === "ERR_CANCELED") return;

        if (err?.response?.status === 404) setNotFound("Risorsa non più disponibile");
        else setError("Si è verificato un errore durante il recupero dei dati");
      })
      .finally(() => {
        if (reqIdRef.current !== myReqId) return;
        setFetching(false);
      });

    return () => controller.abort();
  }, [token, codiceFiscale]);


  // 2. fetch contratti
  useEffect(() => {
    if (!token || !employee?.id) return;

    const controller = new AbortController();

    (async () => {
      try {
        const contracts = await getEmployeeContractsList(
          token,
          employee.id,
          "payrolls",
          controller.signal
        );
        setContractsData(contracts || "");        
      } catch (err) {
        if (err?.code === "ERR_CANCELED" || err?.name === "CanceledError" || err?.name === "AbortError") return;
        console.error(err);
      }
    })();

    return () => controller.abort();
  }, [token, employee?.id]);

  // 3. fetch ratei
  useEffect(() => {
    if (!token || !employee?.id) return;

    const controller = new AbortController();

    setLoading(true);
    setError(null);

    (async () => {
      try {
        const employeeRateiData = await getRateosEmployeeList(
          token,
          employee.id,
          "attendance",
          controller.signal
        );

        setRateiEmployee(employeeRateiData);
      } catch (error) {
        if (
          error?.code === "ERR_CANCELED" ||
          error?.name === "CanceledError" ||
          error?.name === "AbortError"
        ) {
          return;
        }

        console.error(error);
        setError(error);
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    })();

    return () => controller.abort();
  }, [token, employee?.id]);

  // 4. fetch turno settimanale
  useEffect(() => {
    if (!token || !employee?.id) return;

    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      setShiftLoading(true);

      setEmployeeShift(null);
      setIsSenzaCalendario(false);
      setIsContrattoNonFisso(false);

      const activeContract = employee?.active_contract;
      if (!activeContract) {
        setShiftLoading(false);
        return;
      }

      const shiftType = activeContract.shift_type;
      const hasWeekHours = activeContract.week_hours != null;

      const isFisso = shiftType === "fisso" && hasWeekHours;
      const isSenzaCalendarioTipo = shiftType === "senza_calendario";
      const isNonFisso = shiftType !== "fisso" && shiftType !== "senza_calendario";

      if (isSenzaCalendarioTipo) {
        setIsSenzaCalendario(true);
        setShiftLoading(false);
        return;
      }

      if (isNonFisso) {
        setIsContrattoNonFisso(true);
        setShiftLoading(false);
        return;
      }

      if (!isFisso) {
        setShiftLoading(false);
        return;
      }

      try {
        const employeeId = employee?.id;

        const data = await getEmployeeWeeklyWorkingHour(
          token,
          employeeId,
          "shifts",
          signal
        );
        
        if (!data?.weekly_working_hour) {
          setShiftLoading(false);
          return;
        }

        const wwhId = data.weekly_working_hour;

        const compoundResp = await getWeeklyWorkingHourCompound(
          token,
          null,
          employeeId,
          null,
          signal
        );

        const weeklyWorkingHours = Array.isArray(compoundResp)
          ? compoundResp
          : (compoundResp?.results || []);

        const employeeWeeklyShift = weeklyWorkingHours.find(
          (wwh) => String(wwh.id) === String(wwhId)
        );

        if (!signal.aborted) {
          setEmployeeShift(employeeWeeklyShift || null);
          setShiftLoading(false);
        }
      } catch (error) {
        if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED" || error?.name === "AbortError") return;
        console.error("Error fetching weekly working hour data:", error);
        if (!signal.aborted) setShiftLoading(false);
      }
    })();

    return () => controller.abort();
  }, [
    token,
    employee?.id,
    employee?.active_contract?.id,
    employee?.active_contract?.shift_type,
    employee?.active_contract?.week_hours,
  ]);

  // 5. fetch residui/ferie ecc.
  useEffect(() => {
    const fetchEmployeeBalances = async () => {
      try {
        if (employee && token) {
          const balances = await getEmployeeBalances(
            token,
            employee?.id,
            "attendance"
          );
          setEmployeeBalances(balances);
        } else {
          setEmployeeBalances([]);
        }
      } catch (error) {
        console.error("Error fetching employee balances:", error);
      }
    };

    fetchEmployeeBalances();
  }, [token, employee]);

  // 6. fetch permessi per Ruolo e Autorizzazioni
  useEffect(() => {
    const fetchPermissionsDetailed = async () => {
      if (profile.customer_type === "employee") return;

      if (employee) {
        try {
          const detailed = await getPermissionsDetailed(
            token,
            employee?.id
          );
          setPermissionsDetailed(detailed);

          const directPermissions = detailed
            .filter((p) => p.comes_from === "employee")
            .map((p) => p.codename);
          setPermissions(directPermissions);

          const handlerPerms = detailed.filter(
            (p) => p.role === "handler"
          );
          const employeePerms = detailed.filter(
            (p) => p.role === "employee"
          );
          setHandlerPermissions(handlerPerms);
          setEmployeePermissions(employeePerms);
        } catch (error) {
          console.error(
            "Errore nel recuperare i permessi dettagliati:",
            error
          );
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPermissionsDetailed();
  }, [token, profile.customer_type, employee]);

  // gestione click menu
  const handleMenuItemClick = (menuItemKey) => {
    setActiveMenuItem(menuItemKey === activeMenuItem ? null : menuItemKey);
  };

  // aggiorna docs dopo toggle visibilità in DocumentiContent
  const handleUpdateDocs = (updatedDocs) => {
    setEmployee((prevEmployee) => ({
      ...prevEmployee,
      docs: updatedDocs,
    }));
  };

  const NAV_CTX_KEY = "employees_nav_ctx";

  function getNextCfAfterDelete(currentCf) {
    try {
      const raw = sessionStorage.getItem(NAV_CTX_KEY);
      if (!raw) return { nextCf: null, updatedCtx: null };

      const ctx = JSON.parse(raw);
      const cfs = Array.isArray(ctx?.cfs) ? ctx.cfs.filter(Boolean) : [];

      const idx = cfs.indexOf(currentCf);
      if (idx === -1) return { nextCf: null, updatedCtx: ctx };

      // rimuovo il corrente
      const updatedCfs = cfs.filter((cf) => cf !== currentCf);

      // provo successivo (stesso indice, perché l’array si è “chiuso”)
      const next = updatedCfs[idx] || null;

      // se non c’è successivo, provo precedente
      const prev = updatedCfs[idx - 1] || null;

      const nextCf = next || prev || null;

      const updatedCtx = { ...ctx, cfs: updatedCfs, ts: Date.now() };

      return { nextCf, updatedCtx };
    } catch {
      return { nextCf: null, updatedCtx: null };
    }
  }

  // ELIMINA EMPLOYEE
  const handleDelete = async (cf) => {
    const result = await Swal.fire({
      title: "Sei sicuro?",
      html: `
        <p>Stai eliminando il dipendente <strong>${cf}</strong>, questa azione non può essere annullata!</p>
        <p>Digita <strong>"ELIMINA"</strong> per confermare</p>
      `,
      icon: "warning",
      input: "text",
      inputPlaceholder: "Digita ELIMINA",
      inputValidator: (value) => (value !== "ELIMINA" ? 'Digitare "ELIMINA" per procedere' : null),
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Sì, elimina!",
      cancelButtonText: "Annulla",
    });

    if (!result.isConfirmed || result.value !== "ELIMINA") return;

    // calcolo PRIMA dove andare (così uso ancora currentCf integro)
    const { nextCf, updatedCtx } = getNextCfAfterDelete(cf);

    try {
      await deleteDipendente(token, cf);

      // aggiorno ctx (tolgo il CF eliminato)
      if (updatedCtx) {
        sessionStorage.setItem("employees_nav_ctx", JSON.stringify(updatedCtx));
      }

      Swal.fire("Eliminato!", "Il dipendente è stato eliminato.", "success");

      // NAVIGAZIONE immediata:
      if (nextCf) {
        // se vuoi mantenere la stessa tab, passa ?tab=...
        const params = new URLSearchParams(window.location.search);
        setLocation(`/dipendenti/${nextCf}${params.toString() ? `?${params.toString()}` : ""}`);
      } else {
        // nessun altro dipendente nella lista
        setLocation("/dipendenti");
      }
    } catch (error) {
      console.error("Error deleting employee:", error);
      Swal.fire("Errore!", "Si è verificato un errore durante l'eliminazione del dipendente.", "error");
    }
  };


  // callback per aggiornare i saldi ferie ecc.
  const handleBalanceUpdated = (updatedBalance) => {
    const updatedBalances = employeeBalances.map((balance) => {
      if (balance.id === updatedBalance.id) {
        return updatedBalance;
      }
      return balance;
    });
    setEmployeeBalances(updatedBalances);
  };


  // NOTE DIPENDENTE
  const handleEditNotes = () => {
    setNotesDraft(employee?.notes ?? "");
    setIsEditingNotes(true);
  };

  const handleCancelNotes = () => {
    setNotesDraft("");
    setIsEditingNotes(false);
  };

  const handleSaveNotes = async () => {
    if (!employee?.id || isSavingNotes) return;

    setIsSavingNotes(true);

    try {
      const payload = {
        notes: notesDraft,
      };

      await updateAnagraficaEmployee(token, employee.id, payload);

      // Aggiorna immediatamente le note nella scheda corrente
      setEmployee((prev) => (
        prev ? { ...prev, notes: notesDraft } : prev
      ));

      setIsEditingNotes(false);

      Swal.fire({
        icon: "success",
        title: "Note aggiornate!",
        text: "Le note del dipendente sono state salvate correttamente.",
        showConfirmButton: false,
        timer: 1200,
      });
    } catch (error) {
      console.error("Errore durante il salvataggio delle note:", error);

      Swal.fire({
        icon: "error",
        title: "Errore",
        text: "Impossibile aggiornare le note del dipendente.",
      });
    } finally {
      setIsSavingNotes(false);
    }
  };

  // ---------------- MENU OPTIONS ------------------
  const menuOptions = [
    {
      key: "buste_paga",
      label: "Buste Paga",
      content: () => (
        <BustePagaTab
          key={employee?.id}
          token={token}
          employee={employee}
          profile={profile}
          onPreview={setPreviewDoc}
        />
      ),
    },
    {
      key: "certificazioni",
      label: "Certificazioni Uniche",
      content: () => (
        <CuTabEmployee
          key={employee?.id}
          token={token}
          employee={employee}
          profile={profile}
          onPreview={setPreviewDoc}
        />
      ),
    },
    {
      key: "documenti",
      label: "Documenti",
      content: () => (
        <DocumentiContent
          employee={employee}
          profile={profile}
          token={token}
          onUpdateDocs={handleUpdateDocs}
          selectedTab={documentsTab}
          onSelectedTabChange={setDocumentsTab}
        />
      ),
    },
    {
      key: "contratto",
      label: "Contratto",
      content: () => RenderContrattoContent(employee, contractsData),
    },
    {
      key: "ratei",
      label: "Ratei",
      content: () =>
        hasConsultalaHRPro
          ? RenderRateiContent(employee, rateiEmployee)
          : <NotAuthorized />,
    },
    {
      key: "residui",
      label: "Residui",
      content: () =>
        hasConsultalaHRPro ? (
          <ResiduiContent
            employee={employee}
            employeeBalances={employeeBalances}
            token={token}
            onBalanceUpdated={handleBalanceUpdated}
          />
        ) : (
          <NotAuthorized />
        ),
    },
    {
      key: "turno",
      label: "Turno",
      content: () =>
        hasConsultalaHRPro ? (
          RenderTurnoContent(
            employee,
            employeeShift,
            profile,
            isContrattoNonFisso,
            isSenzaCalendario, 
            shiftLoading
          )
        ) : (
          <NotAuthorized />
        ),
    },
    {
      key: "timbratura",
      label: "Timbratura",
      content: () =>
        hasConsultalaHRPro ? (
          RenderTimbraturaContent(employee, profile)
        ) : (
          <NotAuthorized />
        ),
    },
    {
      key: "veicoli",
      label: "Veicoli",
      content: () =>
        hasConsultalaHRPro ? (
          RenderVeicoliContent(employee, profile)
        ) : (
          <NotAuthorized />
        ),
    },
    {
      key: "ruolo_autorizzazioni",
      label: "Ruolo e Autorizzazioni",
      content: () =>
        profile.customer_type !== "employee" ? (
          hasConsultalaHRPro ? (
            RenderRuoloContent(
              employee,
              permissions,
              handlerPermissions,
              employeePermissions,
              permissionsDetailed
            )
          ) : (
            <NotAuthorized />
          )
        ) : (
          <NoPermissions />
        ),
    },
  ];

  // costruiamo il contenuto attivo UNA VOLTA SOLA
  const activeMenuObj = menuOptions.find(
    (item) => item.key === activeMenuItem
  );
  const activeMenuContent = activeMenuObj
    ? activeMenuObj.content()
    : null;

  // ---------------- RENDER ------------------------

  return (
    <>
      <div className="flex flex-col min-h-screen">
        {/* HEADER */}
        <Popover as="header" className="bg-indigo-200">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
              <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
                <div className="flex justify-center my-2 py-2">
                  <h2 className="text-center text-2xl font-semibold text-indigo-800">
                    {!fetching && employee
                      ? employee.last_name && employee.first_name
                        ? `${employee.last_name} ${employee.first_name}`
                        : employee.cf
                      : "Caricando le informazioni..."}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </Popover>

        <main className="mt-10 pb-8 flex-grow">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">

            {/* VISUALIZZAZIONE >= MD */}
            <div className="hidden md:grid grid-cols-3 items-center">
              {/* SINISTRA */}
              <div className="flex justify-start">
                <BackButton prevLocation="/dipendenti" />
              </div>

              {/* CENTRO */}
              <div className="flex justify-center">
                <EmployeesPrevNextNav
                  token={token}
                  currentCf={codiceFiscale}
                  buildPath={(cf, ctx) => `/dipendenti/${cf}${ctx ? `?${new URLSearchParams(ctx).toString()}` : ""}`}
                />
              </div>

              {/* DESTRA */}
              <div className="flex justify-end">
                {!fetching && employee && (
                  <div className="flex items-center gap-2">
                    <Link
                      to={`/dipendenti/${employee.cf}/edit`}
                      className="border rounded-md bg-grey-400 px-3 py-2 text-center text-sm font-semibold text-grey-800 w-24 shadow-sm hover:bg-gray-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600"
                    >
                      Modifica
                    </Link>

                    <button
                      className="border rounded-md bg-grey-400 px-3 py-2 text-center text-sm font-semibold text-grey-800 w-24 shadow-sm hover:bg-red-500 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600"
                      onClick={() => handleDelete(employee.cf)}
                    >
                      Elimina
                    </button>
                  </div>
                )}
              </div>
            </div>
            
            {/* VISUALIZZAZIONE < MD */}
            <div className="grid grid-cols-2 items-center md:hidden">
              {/* SINISTRA */}
              <div className="flex justify-start">
                <BackButton prevLocation="/dipendenti" />
              </div>

              {/* CENTRO */}
              <div className="flex justify-end">
                {!fetching && employee && (
                  <div className="flex items-center gap-2">
                    <Link
                      to={`/dipendenti/${employee.cf}/edit`}
                      className="border rounded-md bg-grey-400 px-3 py-2 text-center text-sm font-semibold text-grey-800 w-24 shadow-sm hover:bg-gray-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600"
                    >
                      Modifica
                    </Link>

                    <button
                      className="border rounded-md bg-grey-400 px-3 py-2 text-center text-sm font-semibold text-grey-800 w-24 shadow-sm hover:bg-red-500 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600"
                      onClick={() => handleDelete(employee.cf)}
                    >
                      Elimina
                    </button>
                  </div>
                )}
              </div>

              {/* DESTRA */}
              <div className="col-span-2 flex justify-center pt-6">
                <EmployeesPrevNextNav
                  token={token}
                  currentCf={codiceFiscale}
                  buildPath={(cf, ctx) => `/dipendenti/${cf}${ctx ? `?${new URLSearchParams(ctx).toString()}` : ""}`}
                />
              </div>
            </div>

            {notFound && (
              <p className="flex items-center justify-center bg-gray-100 rounded-md py-8 text-gray-700 text-md font-semibold">
                {notFound}
              </p>
            )}

            {/* CONTENUTO PRINCIPALE */}
            <div className="">
              {fetching && <Fetching />}

              {!fetching && employee && (
                <>
                  {/* scheda anagrafica sintetica */}
                  <div className="bg-white px-6 pt-6 pb-4">
                    <div className="mx-auto max-w-2xl text-center">
                      <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-2xl">
                        {employee.last_name} {employee.first_name}
                        <br />
                        <small>{employee.cf}</small>
                      </h2>

                      <p className="mt-4 text-lg leading-8 text-gray-600">
                        {employee.email_auth}
                      </p>

                      <p className="text-sm font-semibold text-gray-900">
                        {employee?.app_activate ? (
                          <>
                            <span className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-green-400 bg-green-50 px-3 py-1 text-xs font-semibold text-green-700 me-2">
                              <CheckCircleIcon className="h-4 w-4" />
                              APP ATTIVA
                            </span>
                            <CustomTooltipComponent title="Disattiva Accesso">
                              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 hover:bg-gray-100 hover:text-gray-700 cursor-pointer">
                                <Link
                                  to={`/dipendenti/${employee.cf}/edit`}
                                  title="Disattiva app"
                                >
                                  <PowerIcon className="h-4 w-4" />
                                </Link>
                              </span>
                            </CustomTooltipComponent>
                          </>
                        ) : (
                          <>
                            <span className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-red-400 bg-red-50 px-3 py-1 text-xs font-semibold text-red-700 me-2">
                              <XCircleIcon className="h-4 w-4" />
                              APP NON ATTIVA
                            </span>
                            <CustomTooltipComponent title="Attiva Accesso">
                              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 hover:bg-gray-100 hover:text-gray-700 cursor-pointer">
                                <Link
                                  to={`/dipendenti/${employee.cf}/edit`}
                                  title="Attiva app"
                                >
                                  <PowerIcon className="h-4 w-4" />
                                </Link>
                              </span>
                            </CustomTooltipComponent>
                          </>
                        )}
                      </p>

                      <div className="flex align-center justify-center mt-3">
                        <Link
                          to={`/dipendenti/${employee.cf}/details`}
                          type="button"
                          className="mt-3 block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-300 w-40"
                        >
                          Anagrafica
                        </Link>

                        <button
                          type="button"
                          className="ml-4 mt-3 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-300 w-40"
                          onClick={resetPassword}
                        >
                          Reset Password
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* NOTE DIPENDENTE */}
                  <div className="my-2 mr-6 ml-4 md:ml-6 md:mr-8 lg:ml-2 xl:ml-8 rounded-lg border border-indigo-100 bg-indigo-50/50 p-3 text-left">

                    {/* INTESTAZIONE E AZIONI */}
                    <div className="flex flex-wrap items-center justify-between gap-3">

                      <div className="flex items-center gap-2">
                        <ChatBubbleLeftEllipsisIcon className="h-5 w-5 shrink-0 text-indigo-600" />

                        <h3 className="text-xs font-semibold uppercase tracking-wide text-indigo-800">
                          Note dipendente
                        </h3>
                      </div>

                      {!isEditingNotes ? (
                        <button
                          type="button"
                          onClick={handleEditNotes}
                          className="inline-flex items-center rounded-md bg-indigo-600 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-indigo-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                        >
                          {employee?.notes?.trim() ? "Modifica note" : "Aggiungi note"}
                        </button>
                      ) : (
                        <div className="flex items-center gap-2">

                          <button
                            type="button"
                            onClick={handleCancelNotes}
                            disabled={isSavingNotes}
                            className="inline-flex items-center rounded-md border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-semibold text-gray-700 shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
                          >
                            Annulla
                          </button>

                          <button
                            type="button"
                            onClick={handleSaveNotes}
                            disabled={
                              isSavingNotes ||
                              notesDraft === (employee?.notes ?? "")
                            }
                            className="inline-flex items-center rounded-md bg-indigo-600 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:cursor-not-allowed disabled:opacity-50"
                          >
                            {isSavingNotes ? "Salvataggio..." : "Salva"}
                          </button>

                        </div>
                      )}
                    </div>

                    {/* CONTENUTO NOTE */}
                    <div className="mt-3">

                      {isEditingNotes ? (
                        <textarea
                          id="employee-notes"
                          rows={4}
                          value={notesDraft}
                          onChange={(e) => setNotesDraft(e.target.value)}
                          disabled={isSavingNotes}
                          placeholder="Inserisci eventuali note relative al dipendente..."
                          className="min-h-[110px] w-full resize-y rounded-md border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-60"
                        />
                      ) : (
                        <div className="whitespace-pre-wrap break-words text-sm leading-6 text-gray-700">
                          {employee?.notes?.trim() ? (
                            employee.notes
                          ) : (
                            <span className="italic text-gray-400">
                              Nessuna nota inserita
                            </span>
                          )}
                        </div>
                      )}

                    </div>
                  </div>

                  {/* LAYOUT A DUE COLONNE:
                      - sinistra = menu tab
                      - destra = contenuto tab attiva
                      NOTA: qui renderizziamo activeMenuContent UNA SOLA VOLTA */}
                  {/* LAYOUT RESPONSIVE TABS + CONTENUTO */}
                  <div className="flex min-h-full flex-col">
                    <div className="mx-auto w-full max-w-7xl grow lg:flex xl:px-2">
                      <div className="flex-1 xl:flex">
                        {/* SIDEBAR / MENU */}
                        <div className="border-b px-4 sm:px-6 lg:pl-2 xl:w-72 xl:shrink-0 xl:border-b-0 xl:pl-6 flex-wrap">
                          {menuOptions.map((menuItem) => {
                            const isActive = activeMenuItem === menuItem.key;
                            return (
                              <div
                                key={menuItem.key}
                                className="flex flex-col overflow-hidden rounded-lg shadow-lg mt-2 mb-2 bg-white"
                              >
                                {/* HEADER DELLA TAB */}
                                <div
                                  onClick={() => handleMenuItemClick(menuItem.key)}
                                  className={`cursor-pointer px-3 py-2 rounded-t-md xl:rounded-md relative ${
                                    isActive ? "bg-indigo-50" : ""
                                  }`}
                                  style={
                                    isActive
                                      ? {
                                          textDecoration: "underline",
                                          textDecorationColor: "#6d28d9",
                                          textUnderlineOffset: "8px",
                                        }
                                      : {}
                                  }
                                >
                                  <div className="flex flex-1 flex-col justify-between p-6">
                                    <p className="text-base font-semibold text-gray-900">
                                      {menuItem.label}
                                    </p>
                                  </div>
                                </div>

                                {/* SOLO SE MOBILE E TAB ATTIVA */}
                                {!isDesktop && isActive && (
                                  <div className="px-4 pb-4 sm:px-6">
                                    <div className="px-4 pt-2">{menuItem.content()}</div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>

                        {/* SOLO SE DESKTOP */}
                        {isDesktop && (
                          <div className="px-4 mt-6 lg:mt-0 lg:pt-0 pb-3 sm:px-6 lg:pl-8 xl:flex-1 xl:pl-6">
                            <div className="flex flex-col mt-2">
                              <div className="align-middle min-w-full overflow-x-auto overflow-y-auto shadow overflow-hidden sm:rounded-lg">
                                {activeMenuItem && (
                                  <div className="p-0 sm:px-4 pb-6 sm:pt-2">
                                    <div className="px-4">{activeMenuContent}</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <FilePreviewModal
                    doc={previewDoc}
                    onClose={() => setPreviewDoc(null)}
                  />
                </>
              )}
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}

const SvgBreak = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 117 122.88" style={{ width: '15px' }}>
          <g>
              <path d="M94.8,15.36c-1.18-0.34-1.86-1.56-1.53-2.74c0.34-1.18,1.56-1.86,2.74-1.53c3.15,0.9,5.79,2.39,7.82,4.59 c2.03,2.22,3.39,5.1,3.94,8.79c0.18,1.21-0.66,2.34-1.88,2.52c-1.21,0.18-2.34-0.66-2.52-1.88c-0.41-2.76-1.38-4.87-2.81-6.43 C99.13,17.12,97.17,16.04,94.8,15.36L94.8,15.36z M37.87,67.17L0.61,28.09c-0.84-0.89-0.81-2.29,0.08-3.13 c0.43-0.41,0.98-0.61,1.53-0.61v-0.01h14.53L2.27,9.86c-0.87-0.87-0.87-2.27,0-3.14c0.87-0.87,2.27-0.87,3.14,0l17.62,17.62h42.2 c0.46-6.48,3.24-12.31,7.52-16.64C77.44,2.94,83.92,0,91.08,0c7.16,0,13.64,2.94,18.34,7.7C114.1,12.45,117,19,117,26.23 c0,7.23-2.9,13.78-7.58,18.53c-4.7,4.76-11.18,7.7-18.34,7.7c-3.19,0-6.25-0.59-9.09-1.66c-2.33-0.88-4.51-2.1-6.48-3.6L56,67.18 v38.38l14.94,13.45c0.91,0.82,0.98,2.22,0.16,3.13c-0.44,0.49-1.04,0.73-1.65,0.73v0H24.77c-1.23,0-2.22-0.99-2.22-2.22 c0-0.7,0.32-1.32,0.82-1.73l14.5-13.36V67.17L37.87,67.17z M69.68,24.34h22.88c1.23,0,2.22,0.99,2.22,2.22 c0,0.66-0.29,1.26-0.75,1.67L78.64,44c1.5,1.08,3.15,1.98,4.92,2.65c2.33,0.88,4.87,1.37,7.52,1.37c5.93,0,11.3-2.43,15.18-6.36 c3.89-3.94,6.3-9.39,6.3-15.42c0-6.03-2.41-11.48-6.3-15.42c-3.88-3.93-9.25-6.36-15.18-6.36c-5.93,0-11.3,2.43-15.18,6.36 C72.42,14.33,70.13,19.06,69.68,24.34L69.68,24.34z M7.4,28.78l6.82,7.15c0.14-0.03,0.29-0.05,0.45-0.05h64.77 c0.28,0,0.54,0.05,0.79,0.14l7.08-7.25H7.4L7.4,28.78z M18.41,40.33l23.18,24.31c0.45,0.41,0.73,0.99,0.73,1.65v40.26h0 c0,0.6-0.24,1.2-0.72,1.63l-11.14,10.26h33.22l-11.29-10.16c-0.5-0.41-0.83-1.03-0.83-1.73V66.28h0.01c0-0.56,0.21-1.11,0.63-1.55 l23.83-24.41H18.41L18.41,40.33z"/>
          </g>
      </svg>
  );
};